import slugify from "./slugify";

// Canonical public URL slug for a herb, derived from its title (herb names in a
// materia medica are effectively unique). Falls back to herb-<id> if unsluggable.
// MUST stay in sync with scripts/lib/herb-seo.js.
export const herbSlug = (herb) =>
  slugify(herb?.title || "") || (herb?.id != null ? `herb-${herb.id}` : "");

const hasText = (v) => typeof v === "string" && v.trim().length > 0;

// A herb page is substantive enough to index only if it has real content.
export const isHerbIndexable = (h) => {
  if (!h) return false;
  const dosageCount = h.dosage && typeof h.dosage === "object" ? Object.keys(h.dosage).length : 0;
  return (
    hasText(h.summary) &&
    hasText(h.medicinal_uses) &&
    (hasText(h.benefits) || dosageCount > 0 || hasText(h.contraindications))
  );
};

export default herbSlug;
